import { LabelProps } from 'recharts';

export const ContributingInitiativesChartLabels = (props: LabelProps) => {
  const { x, y, width, value } = props;

  if (value == null || Number(value) === 0) {
    return null;
  }

  return (
    <text
      x={Number(x) + Number(width) / 2}
      y={Number(y) - 5}
      fill="#333"
      textAnchor="middle"
      fontSize={10}
      fontWeight="500"
    >
      {value}
    </text>
  );
};
